module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateDeviceTemplate[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelTemplateId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateId),
      expression: "templateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant de gabarit / Template ID"
    },
    domProps: {
      "value": (_vm.templateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelDevicePicture[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devicePicture),
      expression: "devicePicture"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.devicePicture = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pictureList), function(picture) {
    return _c('option', {
      domProps: {
        "value": picture.fileName
      }
    }, [_vm._v(_vm._s(picture.pictureReferenceName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "150px",
      "src": _vm._f("s3Image")(("organization_img/" + _vm.devicePicture))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelDeviceModel[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceModel),
      expression: "deviceModel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.deviceModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceModel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelDeviceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceName),
      expression: "deviceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.deviceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelDataTtlSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelDataTtlRaw[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataTTL.raw),
      expression: "dataTTL.raw"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.dataTTL.raw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataTTL, "raw", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelDataTtlHr[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataTTL.hr),
      expression: "dataTTL.hr"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.dataTTL.hr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataTTL, "hr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelDataTtlDay[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataTTL.day),
      expression: "dataTTL.day"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.dataTTL.day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataTTL, "day", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelSignalSet[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signalSetIndex),
      expression: "signalSetIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signalSetIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.applyNewSignalSet()
      }]
    }
  }, _vm._l((_vm.signalsSetTemplates), function(signalSet, indexSignalSet) {
    return _c('option', {
      domProps: {
        "value": indexSignalSet
      }
    }, [_vm._v(_vm._s(signalSet.signalSetId))])
  }), 0)])]), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleVariables[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableDataFormat[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableDataType[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deviceSignals), function(signal, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.signalName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.signalLabel.FR))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.signalLabel.EN))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.dataFormat))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.dataType))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleControlParameter[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription02[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.controlParameters), function(parameter, index3) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.parameterName))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.parameterLabel.FR))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.parameterLabel.EN))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterDataType[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.dataType))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [(parameter.dataType === 'Bool') ? _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterValue[_vm.actualLanguage]) + " : On/Off")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValue),
        expression: "parameter.dataValue"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.dataValue) ? _vm._i(parameter.dataValue, null) > -1 : (parameter.dataValue)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.dataValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "dataValue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "dataValue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "dataValue", $$c)
          }
        }
      }
    }), _c('span')])])]) : _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterValue[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValue),
        expression: "parameter.dataValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Value"
      },
      domProps: {
        "value": (parameter.dataValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "dataValue", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagVisibleByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagViewByCustomer),
        expression: "parameter.flagViewByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagViewByCustomer) ? _vm._i(parameter.flagViewByCustomer, null) > -1 : (parameter.flagViewByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagViewByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagViewByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagViewByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagViewByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagEditByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagEditByCustomer),
        expression: "parameter.flagEditByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagEditByCustomer) ? _vm._i(parameter.flagEditByCustomer, null) > -1 : (parameter.flagEditByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagEditByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagEditByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagEditByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagEditByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])])])])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.deviceSignals.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.labelChannelToCreate[_vm.actualLanguage]))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelChannelToCreate2[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelsToCreate),
      expression: "channelsToCreate"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "3",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelsToCreate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.compatibleChannelTemplateList), function(template) {
    return _c('option', {
      domProps: {
        "value": template.channelTemplateId
      }
    }, [_vm._v(_vm._s(template.channelName))])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.channelsToCreate.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectApiKey[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApiKey),
      expression: "selectedApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApiKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.overlayParameters.organizationApiKeys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.key
      }
    }, [_vm._v(_vm._s(key.referenceName) + " : " + _vm._s(key.key))])
  }), 0)]), _vm._v(" "), (_vm.selectedApiKey.length > 0) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDeviceTemplate()
      }
    }
  }, [(_vm.templateIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-053ffcb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/OrganizationApiDeviceTemplateAddForm.vue
// module id = 1480
// module chunks = 4